export const isEmpty = (value: undefined) =>
  value === undefined || value === null || value === '';
